import { render, staticRenderFns } from "./BestSellers.vue?vue&type=template&id=79a0c4fe&scoped=true&"
import script from "./BestSellers.vue?vue&type=script&lang=js&"
export * from "./BestSellers.vue?vue&type=script&lang=js&"
import style0 from "./BestSellers.vue?vue&type=style&index=0&id=79a0c4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a0c4fe",
  null
  
)

export default component.exports